import { camelCase } from 'lodash';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { FeatureFlags, FlagKey } from '@/components/providers/FeatureFlagProvider';
import { globalStoreName } from '@/config';
import { Store } from '@/store/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).spoondriftFF = (featureFlag: string, value: any) => {
    useGlobalStore.getState().setFeatureFlagOverride(camelCase(featureFlag) as FlagKey, value);
};

export const useGlobalStore = create<Store>()(
    devtools(
        (set) => ({
            isLoggedIn: false,
            setIsLoggedIn: (isLoggedIn: boolean) => set({ isLoggedIn }, false, 'setIsLoggedIn'),

            isAlertLinesOn: true,
            setIsAlertLinesOn: (isAlertLinesOn: boolean) => set({ isAlertLinesOn }, false, 'setIsAlertLinesOn'),

            isChatOpen: false,
            setIsChatOpen: (isChatOpen: boolean) => set({ isChatOpen }, false, 'setIsChatOpen'),

            hasUnreadChatMessage: false,
            setHasUnreadChatMessage: (hasUnreadChatMessage: boolean) =>
                set({ hasUnreadChatMessage }, false, 'setHasUnreadChatMessage'),

            isScaleToFitAlertLinesOn: false,
            setIsScaleToFitAlertLinesOn: (isScaleToFitAlertLinesOn: boolean) =>
                set({ isScaleToFitAlertLinesOn }, false, 'setIsScaleToFitAlertLinesOn'),

            featureFlagOverrides: {},
            setFeatureFlagOverride: <F extends FlagKey>(featureFlag: F, value: FeatureFlags[F]) =>
                set(
                    (store) => ({ featureFlagOverrides: { ...store.featureFlagOverrides, [featureFlag]: value } }),
                    false,
                    'setFeatureFlagOverride'
                ),

            mockDataSwitches: {},
            setMockDataSwitch: (mockDataKey: string, value: boolean) =>
                set(
                    (store) => ({ mockDataSwitches: { ...store.mockDataSwitches, [mockDataKey]: value } }),
                    false,
                    'setMockDataSwitch'
                ),

            processingSource: 'best',
            setProcessingSource: (processingSource) => set({ processingSource }, false, 'setProcessingSource'),
        }),
        {
            name: globalStoreName,
        }
    )
);
